import { escaparHtml } from './painel-administrativo.utils';

/**
 * Ícone ⓘ com balão de explicação: abre no clique (fixado) e no hover. O balão fixado fecha ao clicar
 * fora ou com Esc e acompanha o ícone quando algo rola; o do hover fecha quando o mouse sai do ícone
 * e do balão. Um balão por vez, posicionado junto do ícone sem sair da tela.
 */
export function dica(texto: string): string {
    return `<button type="button" class="pa-dica" data-dica="${escaparHtml(texto)}" aria-label="Mais informações" aria-expanded="false">`
        + '<i class="fas fa-info-circle"></i></button>';
}

class Dicas {
    private balao: HTMLElement | null = null;
    private origem: HTMLElement | null = null;
    private fixada = false;
    private iniciado = false;

    iniciar(): void {
        if (this.iniciado) {
            return;
        }
        this.iniciado = true;

        document.addEventListener('click', (evento) => {
            const alvo = (evento.target as HTMLElement).closest('[data-dica]') as HTMLElement | null;
            if (alvo) {
                evento.preventDefault();
                if (this.origem === alvo && this.fixada) {
                    this.fechar();
                } else if (this.origem === alvo) {
                    this.fixada = true;
                } else {
                    this.abrir(alvo, true);
                }
                return;
            }
            if (this.balao && !this.balao.contains(evento.target as Node)) {
                this.fechar();
            }
        });

        document.addEventListener('mouseover', (evento) => {
            const alvo = (evento.target as HTMLElement).closest('[data-dica]') as HTMLElement | null;
            if (alvo && !this.fixada && alvo !== this.origem) {
                this.abrir(alvo, false);
            }
        });

        // Sair do ícone para o próprio balão (ou para o ícone dentro do botão) não fecha: dá para ler e selecionar o texto.
        document.addEventListener('mouseout', (evento) => {
            if (!this.balao || this.fixada) {
                return;
            }
            const saiu = evento.target as Node;
            const destino = evento.relatedTarget as Node | null;
            const dentro = (no: Node | null) => !!no && ((this.origem && this.origem.contains(no)) || this.balao.contains(no));
            if (dentro(saiu) && !dentro(destino)) {
                this.fechar();
            }
        });

        document.addEventListener('keydown', (evento) => {
            if (evento.key === 'Escape' && this.balao) {
                this.fechar();
            }
        });

        // Rolar a página ou uma grade: o fixado acompanha o ícone; o do hover fecha.
        document.addEventListener('scroll', () => {
            if (!this.balao) {
                return;
            }
            if (this.fixada && this.origem && document.body.contains(this.origem)) {
                this.posicionar();
            } else {
                this.fechar();
            }
        }, true);
    }

    private abrir(origem: HTMLElement, fixar: boolean): void {
        this.fechar();

        const raiz = (document.querySelector('.pa') as HTMLElement) || document.body;
        const balao = document.createElement('div');
        balao.className = 'pa-balao';
        balao.setAttribute('role', 'tooltip');
        balao.textContent = origem.getAttribute('data-dica') || '';
        raiz.appendChild(balao);

        this.balao = balao;
        this.origem = origem;
        this.fixada = fixar;
        origem.setAttribute('aria-expanded', 'true');
        this.posicionar();
    }

    private posicionar(): void {
        const balao = this.balao;
        const ref = this.origem.getBoundingClientRect();
        const largura = balao.offsetWidth;
        const altura = balao.offsetHeight;
        const margem = 8;
        let esquerda = ref.left + ref.width / 2 - largura / 2;
        esquerda = Math.max(margem, Math.min(esquerda, window.innerWidth - largura - margem));
        let topo = ref.bottom + 8;
        balao.classList.remove('pa-balao--acima');
        if (topo + altura > window.innerHeight - margem) {
            topo = ref.top - altura - 8;
            balao.classList.add('pa-balao--acima');
        }
        balao.style.left = `${esquerda}px`;
        balao.style.top = `${topo}px`;
        balao.style.setProperty('--pa-balao-seta', `${ref.left + ref.width / 2 - esquerda}px`);
    }

    private fechar(): void {
        if (this.balao) {
            this.balao.remove();
        }
        if (this.origem) {
            this.origem.setAttribute('aria-expanded', 'false');
        }
        this.balao = null;
        this.origem = null;
        this.fixada = false;
    }
}

export const dicas = new Dicas();
